<template>
  <div class="two-img">
    <div
      class="two-img__wrapper"
      :class="{ 'reverse': reverse }"
    >
      <div
        class="two-img__left-block"
        :class="{ 'framed': leftFrame, 'stl-enable': leftPopupId }"
      >
        <div
          v-if="displayLeftMedia"
          class="two-img__image-wrapper two-img__image-wrapper--left"
          :data-gtag-select-content="leftShopTheLook"
          :data-stl-id="leftGtmId"
          :data-open-popup="leftPopupId"
        >
          <media-element
            class="two-img__media two-img__media--left"
            :autoplay-video="leftVideoAutoplay"
            :image="leftImage"
            :image-desktop="leftImageDesktop"
            :inline-media="true"
            :video="leftVideo"
            :video-desktop="leftVideoDesktop"
            :video-external-url="leftVideoExternalUrl"
            :video-external-desktop-url="leftVideoExternalDesktopUrl"
            :loop-video="leftVideoLoop"
          />
          <img
            v-if="leftSvg"
            class="two-img__svg  two-img__svg--left"
            :src="leftSvg"
            alt="SVG"
          >
          <span
            v-if="leftShopTheLook"
            class="two-img__shop-the-look shop-the-look two-img__shop-the-look--left"
            :class="[leftShopTheLookMobile ? 'enable-on-mobile' : '', leftStlLabelPosition]"
            v-text="leftShopTheLookText"
          />
        </div>
        <div
          v-if="leftHeadingText || leftText"
          class="two-img__text-wrapper two-img__text-wrapper--left"
        >
          <div
            class="two-img__heading-wrapper two-img__heading-wrapper--left"
            :class="{'absolute' : leftHeadingAbsolute }"
          >
            <heading
              v-if="leftHeadingText"
              :id="`section-title-${id}`"
              class="two-img__heading two-img__heading--left"
              :type="leftHeadingType"
              :text="leftHeadingText"
              :class="leftHeadingAlign"
            />
          </div>
          <div
            v-if="leftText"
            class="two-img__text two-img__text--left"
            :class="leftTextAlign"
            v-html="leftText"
          />
          <a
            v-if="leftLink"
            :href="leftUrl"
            class="two-img__link two-img__link--left"
            :class="[leftLinkAlign, leftLinkOnMobile ? 'show-on-mobile' : '' ]"
            v-text="leftLink"
          />
        </div>
      </div>
      <div
        class="two-img__right-block"
        :class="{ 'framed': rightFrame, 'stl-enable': rightPopupId }"
      >
        <div
          v-if="displayRightMedia"
          :data-gtag-select-content="rightShopTheLook"
          :data-stl-id="rightGtmId"
          :data-open-popup="rightPopupId"
          class="two-img__image-wrapper two-img__image-wrapper--right"
        >
          <media-element
            class="two-img__media two-img__media--right"
            :autoplay-video="rightVideoAutoplay"
            :image="rightImage"
            :image-desktop="rightImageDesktop"
            :inline-media="true"
            :video="rightVideo"
            :video-desktop="rightVideoDesktop"
            :video-external-url="rightVideoExternalUrl"
            :video-external-desktop-url="rightVideoExternalDesktopUrl"
            :loop-video="rightVideoLoop"
          />
          <img
            v-if="rightSvg"
            class="two-img__svg  two-img__svg--right"
            :src="rightSvg"
            alt="SVG"
          >
          <span
            v-if="rightShopTheLook"
            class="two-img__shop-the-look shop-the-look two-img__shop-the-look--right"
            :class="[rightShopTheLookMobile ? 'enable-on-mobile' : '', rightStlLabelPosition]"
            v-text="rightShopTheLookText"
          />
        </div>
        <div
          v-if="rightHeadingText || rightText"
          class="two-img__text-wrapper two-img__text-wrapper--right"
        >
          <div
            class="two-img__heading-wrapper two-img__heading-wrapper--right"
            :class="{'absolute' : rightHeadingAbsolute }"
          >
            <heading
              v-if="rightHeadingText"
              class="two-img__heading two-img__heading--right"
              :class="rightHeadingAlign"
              :type="rightHeadingType"
              :text="rightHeadingText"
            />
          </div>
          <div
            v-if="rightText"
            class="two-img__text two-img__text--right"
            :class="rightTextAlign"
            v-html="rightText"
          />
          <a
            v-if="rightLink"
            :href="rightUrl"
            class="two-img__link two-img__link--right"
            :class="[rightLinkAlign, rightLinkOnMobile ? 'show-on-mobile': '']"
            v-text="rightLink"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Section: Rich Text Block
 * ------------------------------------------------------------------------------
 * Display rich text from the Theme Customizer.
 * @param {String} [id] - Section's Liquid ID
 * @param {Boolean} [reverse] - Reverse Content on Desktop and Mobile.
 * Settings for Left Column.
 * @param {Object} [leftImage] - A formatted image object.
 * @param {Object} [leftImageDesktop] - A formatted image object specific to Desktop.
 * @param {Object} [leftVideo] - A formatted video object.
 * @param {Object} [leftVideoDesktop] - A formatted video object specific to Desktop.
 * @param {String} [leftVideoExternalUrl] - An external video URL
 * @param {String} [leftVideoExternalDesktopUrl] - An external video URL (desktop)
 * @param {Boolean} [leftVideoAutoplay] - Enable/Disable Video Autoplay.
 * @param {Boolean} [leftVideoLoop] - Enable loop for left block video.
 * @param {String} [leftSvg] - SVG to display.
 * @param {String} [leftTextAlign] - Text alignment.
 * @param {String} [leftHeadingText] - Heading Text to display.
 * @param {String} [leftHeadingType] - Theme Settings for h1-h6 values.
 * @param {Boolean} [leftHeadingAbsolute] - Enable/disable absolute postition of Heading.
 * @param {String} [leftText] - Text content to be shown.
 * @param {String} [leftLink] - Link title to be shown.
 * @param {String} [leftUrl] -  URL of Link on left column.
 * @param {String} [leftLinkAlign] - Link  alignment.
 * @param {Boolean} [leftLinkOnMobile] - Show/hide link on Mobile.
 * @param {Boolean} [leftShopTheLook] - Enable/disable Shop The Look Component.
 * @param {Boolean} [leftShopTheLookMobile] - Show/hide Shop The Look Component.
 * @param {String} [leftGtmId] - GTM Id.
 * @param {String} [leftShopTheLookText] - Title of Shop The Look button.
 * @param {String} [leftStlPositionMobile] - Position of Shop The Look button on Mobile devices.
 * @param {String} [leftStlPositionDesktop] - Position of Shop The Look button on Desktop.
 * @param {String} [leftShopTheLookPopup] - Shop The Look Popup ID
 * Settings for Right Column.
 * @param {Object} [rightImage] - A formatted image object.
 * @param {Object} [rightImageDesktop] - A formatted image object specific to Desktop.
 * @param {Object} [rightVideo] - A formatted video object.
 * @param {Object} [rightVideoDesktop] - A formatted video object specific to Desktop.
 * @param {String} [rightVideoExternalUrl] - An external video URL
 * @param {String} [rightVideoExternalDesktopUrl] - An external video URL (desktop)
 * @param {Boolean} [rightVideoAutoplay] - Enable/Disable Video Autoplay.
 * @param {Boolean} [rightVideoLoop] - Enable loop for right block video.
 * @param {String} [rightSvg] - SVG to display.
 * @param {String} [rightTextAlign] - Text alignment.
 * @param {String} [rightHeadingText] - Heading Text to display.
 * @param {String} [rightHeadingType] - Theme Settings for h1-h6 values.
 * @param {Boolean} [rightHeadingAbsolute] - Enable/disable absolute postition of Heading.
 * @param {String} [rightText] - Text content to be shown.
 * @param {String} [rightLink] - Link title to be shown.
 * @param {String} [rightUrl] -  URL of Link on left column.
 * @param {String} [rightLinkAlign] - Link  alignment.
 * @param {Boolean} [rightLinkOnMobile] - Show/hide link on Mobile.
 * @param {Boolean} [rightShopTheLook] - Enable/disable Shop The Look Component.
 * @param {Boolean} [rightShopTheLookMobile] - Show/hide Shop The Look Component.
 * @param {String} [rightGtmId] - GTM Id.
 * @param {String} [rightShopTheLookText] - Title of Shop The Look button.
 * @param {String} [rightStlPositionMobile] - Position of Shop The Look button on Mobile devices.
 * @param {String} [rightStlPositionDesktop] - Position of Shop The Look button on Desktop.
 * @param {String} [rightShopTheLookPopup] - Shop The Look Popup ID
 */

import { mapState } from 'pinia'

import { useScreenStore } from '~stores/screen'

import MediaElement from '~components/media-element/media-element'

import Heading from '~components/heading/heading'

export default {
  name: 'FiftyFifty',
  components: {
    MediaElement,
    Heading,
  },

  props: {
    id: {
      type: String,
      default: '',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    leftImage: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    leftImageDesktop: {
      type: [Boolean, Object],
      default: false,
    },
    leftVideo: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    leftVideoDesktop: {
      type: [Boolean, Object],
      default: false,
    },
    leftVideoExternalUrl: {
      type: String,
      default: '',
    },
    leftVideoExternalDesktopUrl: {
      type: String,
      default: '',
    },
    leftVideoAutoplay: {
      type: Boolean,
      default: true,
    },
    leftVideoLoop: {
      type: Boolean,
      default: false,
    },
    leftFrame: {
      type: Boolean,
      default: false,
    },
    leftSvg: {
      type: String,
      default: '',
    },
    leftTextAlign: {
      type: String,
      default: '',
    },
    leftHeadingText: {
      type: String,
      default: '',
    },
    leftHeadingType: {
      type: String,
      default: 'h2',
    },
    leftHeadingAlign: {
      type: String,
      default: '',
    },
    leftHeadingAbsolute: {
      type: Boolean,
      default: false,
    },
    leftText: {
      type: String,
      default: '',
    },
    leftLink: {
      type: String,
      default: '',
    },
    leftUrl: {
      type: String,
      default: '',
    },
    leftLinkAlign: {
      type: String,
      default: '',
    },
    leftLinkOnMobile: {
      type: Boolean,
      default: true,
    },
    leftShopTheLook: {
      type: Boolean,
      default: true,
    },
    leftShopTheLookMobile: {
      type: Boolean,
      default: true,
    },
    leftGtmId: {
      type: String,
      default: '',
    },
    leftShopTheLookText: {
      type: String,
      default: '',
    },
    leftShopTheLookPopup: {
      type: String,
      default: null,
    },
    leftStlPositionMobile: {
      type: String,
      default: '',
    },
    leftStlPositionDesktop: {
      type: String,
      default: '',
    },
    rightImage: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    rightImageDesktop: {
      type: [Boolean, Object],
      default: false,
    },
    rightVideo: {
      type: [Boolean, Object],
      default: false,
    },
    rightVideoDesktop: {
      type: [Boolean, Object],
      default: false,
    },
    rightVideoExternalUrl: {
      type: String,
      default: '',
    },
    rightVideoExternalDesktopUrl: {
      type: String,
      default: '',
    },
    rightVideoAutoplay: {
      type: Boolean,
      default: true,
    },
    rightVideoLoop: {
      type: Boolean,
      default: false,
    },
    rightFrame: {
      type: Boolean,
      default: false,
    },
    rightSvg: {
      type: String,
      default: '',
    },
    rightTextAlign: {
      type: String,
      default: '',
    },
    rightHeadingText: {
      type: String,
      default: '',
    },
    rightHeadingType: {
      type: String,
      default: 'h2',
    },
    rightHeadingAlign: {
      type: String,
      default: '',
    },
    rightHeadingAbsolute: {
      type: Boolean,
      default: false,
    },
    rightText: {
      type: String,
      default: '',
    },
    rightLink: {
      type: String,
      default: '',
    },
    rightUrl: {
      type: String,
      default: '',
    },
    rightLinkAlign: {
      type: String,
      default: '',
    },
    rightLinkOnMobile: {
      type: Boolean,
      default: true,
    },
    rightShopTheLook: {
      type: Boolean,
      default: true,
    },
    rightShopTheLookMobile: {
      type: Boolean,
      default: true,
    },
    rightShopTheLookText: {
      type: String,
      default: '',
    },
    rightShopTheLookPopup: {
      type: String,
      default: null,
    },
    rightStlPositionMobile: {
      type: String,
      default: '',
    },
    rightStlPositionDesktop: {
      type: String,
      default: '',
    },
    rightGtmId: {
      type: String,
      default: ' ',
    },
  },

  computed: {

    /**
     * Map global state.
     */
    ...mapState(useScreenStore, {
      isMobile: 'mobile',
    }),

    /**
     * Calculates the ID for the left 'Shop The Look'.
     * @returns {Boolean|String}
     */
    leftPopupId() {
      if (!this.leftShopTheLook) {
        return false
      }

      return this.leftShopTheLookPopup
    },

    /**
     * Calculates the ID for the right 'Shop The Look'.
     * @returns {Boolean|String}
     */
    rightPopupId() {
      if (!this.rightShopTheLook) {
        return false
      }

      return this.rightShopTheLookPopup
    },

    /**
     * Calculate Shop The Look Label classes.
     * @returns {String}
     */
    leftStlLabelPosition() {
      let labelClass = ''

      if (this.isMobile) {
        labelClass = this.leftStlPositionMobile
      } else {
        labelClass = this.leftStlPositionDesktop
      }

      return labelClass
    },

    /**
     * Calculate right Shop The Look Label classes.
     * @returns {String}
     */
    rightStlLabelPosition() {
      let labelClass = ''

      if (this.isMobile) {
        labelClass = this.rightStlPositionMobile
      } else {
        labelClass = this.rightStlPositionDesktop
      }

      return labelClass
    },

    /**
     * Calculate if to display the left-column media.
     * @returns {Boolean}
     */
    displayLeftMedia() {
      if (this.isMobile) {
        return this.leftImage || this.leftVideo || this.leftVideoExternalUrl
      }

      return this.leftImageDesktop || this.leftVideoDesktop ||
        this.leftVideoExternalDesktopUrl || this.leftVideoExternalUrl
    },

    /**
     * Calculate if to display the right-column media.
     * @returns {Boolean}
     */
    displayRightMedia() {
      if (this.isMobile) {
        return this.rightImage || this.rightVideo || this.rightVideoExternalUrl
      }

      return this.rightImageDesktop || this.rightVideoDesktop ||
        this.rightVideoExternalDesktopUrl || this.rightVideoExternalUrl
    },
  },
}
</script>

<style src="./two-img.scss" lang="scss"></style>
